export const HOMEOWNERS_FORM_COMMUNICATION = 'homeowners_forms_communication';
export const COMMERCIAL_OWNER_EXPERIMENT = 'commercial_owner_widget_title';
export const HOMEOWNERS_NEW_ADD_FORM = 'homeowner_new_add_form';
